<template>
    <li>
        <ul
            role="list"
            class="space-y-1"
        >
            <slot />
        </ul>
    </li>
</template>
